import React from 'react';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { ExperimentStatus } from 'apps/experiments/src/types';
import { ExperimentPageBannerConfigure } from './_configure';
import { ExperimentPageBannerAddMetrics } from './_add-metrics';
import { ExperimentPageBannerLaunch } from './_launch';
import { ExperimentPageBannerRunning } from './_running';
import { ExperimentPageBannerReview } from './_review';
import { ExperimentPageBannerSucceeded } from './_succeeded';
import { ExperimentPageBannerFailed } from './_failed';
export function ExperimentPageBanner() {
  const experimentState = useExperimentsStore(state => state.experimentState!);
  switch (experimentState.status) {
    case ExperimentStatus.DRAFT:
      if (!experimentState.settings.collectionMethod) {
        return <ExperimentPageBannerConfigure />;
      } else if (experimentState.metrics.length === 0) {
        return <ExperimentPageBannerAddMetrics />;
      } else {
        return <ExperimentPageBannerLaunch />;
      }
    case ExperimentStatus.ACTIVE:
      return <ExperimentPageBannerRunning />;
    case ExperimentStatus.CONCLUDED:
      return <ExperimentPageBannerReview />;
    case ExperimentStatus.SUCCESS:
      return <ExperimentPageBannerSucceeded />;
    case ExperimentStatus.FAIL:
      return <ExperimentPageBannerFailed />;
    default:
      return null;
  }
}